const million = 1000000;
const thousand = 1000;

function removeOptionalDigit(value){
	let bodys = value.toString().split(".");
	if(bodys.length === 1){
		return bodys[0];
	}
	const tail = bodys[1];
	let validTailLastIndex = 0;
	for(let i=0;i<tail.length;i+=1){
		if(parseInt(tail[i], 10) !== 0){
			validTailLastIndex = i+1;
		}
	}
	if(validTailLastIndex === 0){
		return bodys[0];
	}
	let tailMap = "";
	for(let i=0;i<validTailLastIndex;i+=1){
		tailMap += tail[i];
	}
	return `${bodys[0]}.${tailMap}`;
}
/**
 * Convert 10000 into 10K like format with digit.
 * @param {number} value 
 * @param {number} digit 
 */
function numberToUnit(value, digit = 2){
	if(value >= million){
		return removeOptionalDigit((value / million).toFixed(digit, 10)) +"M";
	}else if(value >= thousand){
		return removeOptionalDigit((value / thousand).toFixed(digit, 10)) +"K";
	}
	return value;
}

export default { numberToUnit };


// WEBPACK FOOTER //
// ./src/util/number.js